import React from 'react';

import { Box } from '@shopify/polaris';

interface ResizeableSekeletonTextProps {
    width?: string;
    height?: string;
    color?: 'bg-fill-active' | 'bg-fill-tertiary';
    borderRadius?: '100' | '750';
}

const ResizeableSekeletonText: React.FC<ResizeableSekeletonTextProps> = ({
    height = 'var(--p-font-line-height-400)',
    width = '100%',
    color = 'bg-fill-active',
    borderRadius = '100',
}) => <Box minHeight={height} width={width} borderRadius={borderRadius} background={color} />;

export default ResizeableSekeletonText;
